import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

function visitorId() {
  const now = Date.now();
  let raw = localStorage.getItem("lfc_vid");
  let [id, born] = raw ? raw.split("|") : [];
  const MAX = 400 * 24 * 3600 * 1000; // 13 mois max (mesure d'audience exemptée)
  if (!id || !born || now - Number(born) > MAX) {
    id = Math.random().toString(36).slice(2) + now.toString(36);
    localStorage.setItem("lfc_vid", `${id}|${now}`);
  }
  return id;
}

/** UTM de la visite, mémorisés pour la session (première page vue). */
function campaign(search) {
  const q = new URLSearchParams(search);
  const fresh = ["utm_source", "utm_medium", "utm_campaign"].reduce((acc, k) => {
    const v = q.get(k);
    if (v) acc[k] = v.slice(0, 80);
    return acc;
  }, {});
  if (Object.keys(fresh).length) {
    sessionStorage.setItem("lfc_utm", JSON.stringify(fresh));
    return fresh;
  }
  try {
    return JSON.parse(sessionStorage.getItem("lfc_utm") || "{}");
  } catch {
    return {};
  }
}

/** Mesure d'audience interne, anonyme. */
export default function useAudience() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    api.post("/track", {
      path: pathname,
      vid: visitorId(),
      ref: document.referrer || "direct",
      ...campaign(search),
    }).catch(() => {});
  }, [pathname, search]);
}
